import React from 'react';
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'

import FxView from '../../../components/FxView/fxview'
import ServiciosDeCoachATorneos from '../../../components/Bellavista/ServiciosDeCoachATorneos/servicioscoachbellavista'




const EscuelaDeFormacion = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />
      <ServiciosDeCoachATorneos />




      <Footer />
      <></>
    </div>
  )
}

export default EscuelaDeFormacion
